import { Dispatch, SetStateAction, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useCustomNavigate } from 'app/utils/customHooks/useCustomNavigate';

import { deleteBtn, dialogActions, dialogTitle, paperProps, title } from './TemplateModals.sx';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  id?: any;
  deleteTemplate?: any;
  isEdit?: any;
  data?: any;
}

const DeleteTemplateModal = (props: Props) => {
  const { open, close, deleteTemplate, id, isEdit, data } = props;
  const navigate = useCustomNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (isEdit && data?.result === 'accepted') {
      navigate('templates-page', { state: { deleted: true } });
    }
  }, [data]);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '48px' }}>
          <Typography sx={title}>{t('templates.deleteTemplateDesc')}</Typography>
        </DialogTitle>
        <DialogActions sx={dialogActions}>
          <Button
            sx={deleteBtn}
            onClick={() => {
              deleteTemplate({
                id,
                content_data: {
                  state: 'deleted',
                },
              });
              if (!isEdit) {
                close(false);
              }
            }}
          >
            {t('templates.deleteTemplate')}
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
            }}
          >
            {t('commonActions.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteTemplateModal;
